// Single source of truth for reading the current Cognito session/tokens under
// Amplify v6. Replaces the scattered v5 `Auth.currentSession().getIdToken()...`
// call sites so the rest of the app doesn't touch aws-amplify/auth directly.
import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';

export async function getIdToken() {
  const { tokens } = await fetchAuthSession();
  return tokens?.idToken?.toString() ?? null;
}

export async function getAccessToken() {
  const { tokens } = await fetchAuthSession();
  return tokens?.accessToken?.toString() ?? null;
}

export async function getCurrentUsername() {
  try {
    const user = await getCurrentUser();
    return user?.username ?? null;
  } catch {
    return null; // not signed in
  }
}

// Email claim from the id token (already present after login — no extra call).
export async function getUserEmail() {
  const { tokens } = await fetchAuthSession();
  return tokens?.idToken?.payload?.email ?? null;
}

export async function refreshSession() {
  await fetchAuthSession({ forceRefresh: true });
}
